import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface LoadingStateProps {
  title?: string | ReactNode
  action?: ReactNode
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  align?: 'flex-start' | 'flex-end' | 'center'
}

export default function LoadingState({
  title,
  action,
  size = 'lg',
  align = 'center'
}: LoadingStateProps) {
  const boxHeight = computeBoxHeight()
  const circularProgressSize = computeCircularProgressSize()

  function computeBoxHeight(): string {
    switch (size) {
      case 'xs':
        return '1rem'
      default:
        return '10rem'
    }
  }

  function computeCircularProgressSize(): string {
    switch (size) {
      case 'xs':
        return '1rem'
      default:
        return '5vh'
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: align,
        justifyContent: 'center',
        height: boxHeight
      }}
    >
      <Stack direction="column" justifyContent="center" alignItems="center" gap={3}>
        <CircularProgress size={circularProgressSize} />
        {typeof title === 'string' ? (
          <Typography variant="subtitle1" fontWeight={500}>
            {title}
          </Typography>
        ) : (
          title
        )}

        {action}
      </Stack>
    </Box>
  )
}
